import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { resetPassword } from "../services/authService";

const ResetPasswordForm = ({ token }) => {
  const [formData, setFormData] = useState({
    token: token,
    newPassword: "",
    confirmPassword: "",
  });

  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    if (formData.newPassword !== formData.confirmPassword) {
      setMessage("❌ Passwords do not match!");
      setLoading(false);
      return;
    }

    try {
      const result = await resetPassword(formData);
      if (result.success) {
        setMessage("✅ " + result.message);
        setTimeout(() => navigate("/login"), 2000);
      } else {
        setMessage("❌ " + result.message);
      }
    } catch (error) {
      setMessage("❌ Error connecting to the server.");
    }

    setLoading(false);
  };

  return (
    <div className="d-flex justify-content-center align-items-center mt-3 mb-3">
      <div className="card shadow-lg p-4 w-100" style={{ maxWidth: "400px" }}>
        <h3 className="text-center mb-3">Reset Password</h3>
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label">New Password</label>
            <input
              type="password"
              name="newPassword"
              className="form-control"
              placeholder="Enter new password"
              required
              onChange={handleChange}
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Confirm Password</label>
            <input
              type="password"
              name="confirmPassword"
              className="form-control"
              placeholder="Confirm new password"
              required
              onChange={handleChange}
            />
          </div>
          <button className="btn btn-primary w-100" type="submit" disabled={loading}>
            {loading ? "Resetting..." : "Reset Password"}
          </button>
        </form>
        {message && (
          <div className="alert mt-3 text-center" role="alert" style={{ color: message.includes("✅") ? "green" : "red" }}>
            {message}
          </div>
        )}
      </div>
    </div>
  );
};

export default ResetPasswordForm;
